import { get, isEmpty, orderBy } from 'lodash';
import { useCallback } from 'react';
import { useControlsState } from '@shared/components/filter/state/ControlsProvider';
import { SortSelectionState } from '@shared/components/filter/types';

type SortOrder = 'asc' | 'desc';

/*
lodash puts null values to top, we want them to bottom.
Custom iterator (iteratee?) sorts them as 0 when null/undefined.
Forces item to top when asc, bottom when desc.
*/
const FALLBACK_VALUE = 0;

export function useSortedCardList() {
  const { sorts } = useControlsState();

  return useCallback(
    (entities: MBAPI.WorkflowEntity[]) => {
      const allSorts = Array.from(sorts?.values() ?? []);
      return getSortedCards(entities, allSorts);
    },
    [sorts],
  );
}

export function getSortedCards(entities: MBAPI.WorkflowEntity[], sorts: SortSelectionState[]) {
  if (isEmpty(sorts)) {
    return entities;
  }

  const sortIteratees = sorts.map(item => {
    return (entity: MBAPI.WorkflowEntity) => {
      return get(entity, `fields.${item.sort.id}`, FALLBACK_VALUE);
    };
  });
  const sortOrders = sorts.map(getSortOrder);

  return orderBy(entities, sortIteratees, sortOrders);
}

function getSortOrder(sort: SortSelectionState): SortOrder {
  switch (sort.direction) {
    case 'ASC':
      return 'asc';
    case 'DESC':
      return 'desc';
  }
}
